import React from "react";

const dummyPartners = [
  { name: "ABC Motors", type: "OEM" },
  { name: "Global Gear Ltd.", type: "Distributor" },
  { name: "Hydro Solutions", type: "Supplier" },
];

export default function SyntraMfgConnectPage({ onClose }) {
  return (
    <div className="space-y-4">
      <h3 className="font-semibold text-gray-700">OEM & Buyer Connect (Dummy Data)</h3>
      <div className="grid md:grid-cols-2 gap-4">
        {dummyPartners.map((p, idx) => (
          <div key={idx} className="border rounded-lg p-4 bg-gray-50">
            <p className="font-semibold">{p.name}</p>
            <p className="text-sm text-gray-500">Type: {p.type}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
